module.exports = __webpack_public_path__ + "static/ARTS_150-1959a515c5f2621745788848332cc252.png";